import React from 'react';

export const Loading = (props) => {
    return(
        <div className="loading-box">
            <img src={require('../assets/images/loading.gif')}/>
        </div>
    )
}

export default Loading